module.exports = "//docs.gtimg.com/slide/img/slide/application/service/select-window/core/component/images/visible-245599.svg";